'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _SessionTimeoutTracker = require('./SessionTimeoutTracker');

var _SessionTimeoutTracker2 = _interopRequireDefault(_SessionTimeoutTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(sessionTimeoutTrackerObject) {
    var redirectUrl = sessionTimeoutTrackerObject.redirectUrl,
        warningTimeoutMs = sessionTimeoutTrackerObject.warningTimeoutMs;


    if (window.sessionTimeoutTracker) {
        window.sessionTimeoutTracker.redirectUrl = redirectUrl;
        if (warningTimeoutMs) {
            window.sessionTimeoutTracker.warningTimeoutMs = warningTimeoutMs;
        }
        return window.sessionTimeoutTracker;
    }

    return new _SessionTimeoutTracker2.default(sessionTimeoutTrackerObject);
}

function refreshLogOutTimer(inputObject) {
    var statusCode = inputObject.statusCode,
        redirectUrl = inputObject.redirectUrl,
        warningTimeoutMs = inputObject.warningTimeoutMs;


    var sessionTimeoutTrackerObject = { redirectUrl: redirectUrl, warningTimeoutMs: warningTimeoutMs };

    window.sessionTimeoutTracker = init(sessionTimeoutTrackerObject);
    window.sessionTimeoutTracker.refreshLogOutTimer(statusCode);
}

function clearLogOutTimer() {
    if (!window.sessionTimeoutTracker) {
        return;
    }
    window.sessionTimeoutTracker.clearLogOutTimer();
}

var sessionTimeoutTrackerSingleton = { refreshLogOutTimer: refreshLogOutTimer, clearLogOutTimer: clearLogOutTimer };

exports.default = sessionTimeoutTrackerSingleton;